export class Pagos {  
    public fechaPago: any;  
    public valor: any;
    public id: any;   
  }  